
import request from './request';
const http = {
  post(url, data, headers = {}) {
    return request({
      url,
      method: 'post',
      data,
      headers,
    });
  },

  get(url, params, responseType) {
    return request({
      url,
      method: 'get',
      params,
      responseType,
    });
  },
  delete(url, params, responseType) {
    return request({
      url,
      method: 'delete',
      params,
      responseType,
    });
  },
  put(url, data, headers = {}) {
    return request({
      url,
      method: 'put',
      data,
      headers,
    });
  },
  delete(url, data, headers = {}) {
    return request({
      url,
      method: 'delete',
      data,
      headers,
    });
  },
};

export default http;